import * as React from 'react';
import { useTranslation } from '@lib/useTypedTranslation';
import { useState } from 'react';
import moment from 'moment';

import ThresholdSettings from '../thresholdSettings';
import { WorldSettings } from '../../../../services/config/config';

import '../settings.css';

export interface IProps {
  worldSettings: WorldSettings,
  submitInProgress: boolean,
  timeStamp: number,
  onDataChanged: (data: WorldSettings) => void,
  disabled?: boolean
}

const ns = 'settings' as const;

export function BatteryCycleCountSettings(props: IProps) {
  const { t } = useTranslation(ns);
  const [alertTimeStamp, setAlertTimeStamp] = useState<number>(props.timeStamp);

  if (props.timeStamp > alertTimeStamp) {
    setAlertTimeStamp(props.timeStamp);
  }

  function onDataChanged(data: number, field: 'warning' | 'problem') {
    if (field === 'warning') {
      props.onDataChanged({ ...props.worldSettings, batteryCycleCountYellow: data });
    } else {
      props.onDataChanged({ ...props.worldSettings, batteryCycleCountRed: data });
    }
  }

  function onAlertToggled(data: boolean, initialSettings: { warning: number, problem: number }) {
    setAlertTimeStamp(moment.utc().valueOf());
    props.onDataChanged({
      ...props.worldSettings,
      batteryCycleCountEnabled: data,
      batteryCycleCountYellow: initialSettings.warning,
      batteryCycleCountRed: initialSettings.problem,
    });
  }

  return (
    <ThresholdSettings
      key={alertTimeStamp}
      title={t('BATTERY_CYCLE_COUNT_TITLE', { ns })}
      message={t('BATTERY_CYCLE_COUNT_MESSAGE', { ns })}
      popoverText={t('BATTERY_CYCLE_COUNT_POPOVER', { ns })}
      className="cycleCount"
      maxValue={9999}
      warning={props.worldSettings.batteryCycleCountYellow}
      problem={props.worldSettings.batteryCycleCountRed}
      dataUpdated={onDataChanged}
      disabled={props.submitInProgress || !props.worldSettings.batteryCycleCountEnabled}
      alertEnabled={props.worldSettings.batteryCycleCountEnabled}
      alertToggled={onAlertToggled}
    />
  );
}
